import { gql } from "@apollo/client";
import { PRODUCT_AVAILABILITY_FRAGMENT } from "./ProductAvailability";

export const GET_CHECKOUT_PRODUCT = gql`
  query ProductCheckoutQuery(
    $productId: ID!
    $fromDate: Date!
    $untilDate: Date!
    $language: Iso639!
    $currency: Currency!
  ) {
    product(id: $productId) {
      id
      meetingPlaceGoogleMapsQuery {
        placeId
        geoLocation {
          lat
          lng
        }
      }
      hasDefaultVehiclePickup
      hasAccomodationVehiclePickup
      pickupLocationZone {
        center {
          lat
          lng
        }
        radius
      }
      availability(fromDate: $fromDate, untilDate: $untilDate) {
        ...AvailabilityFragment
      }
      availabilityType
      cancellationLimit
      dietaryRestrictions {
        diet
        isPossible
      }
      location {
        id
        translation(lang: $language) {
          name
        }
        country {
          id
          name
        }
      }

      mainImage
      maximumInGroup
      translation(lang: $language) {
        meetingPlaceName
        name
      }
      inclusions {
        id
        index
        icon
        translation(lang: $language) {
          lang
          title
          description
        }
      }
      faqs(lang: $language) {
        id
        createdAt
        productId
        lang
        question
        answer
        index
        imageUrl
      }
      reviews {
        avgStars
        totalRecords
      }
      poster
      cancellationLimit
      prices(currency: $currency) {
        id
        amount
        currency
        minimumPeople
        maximumPeople
        vegetarian
        excludeFromPrivateGroupCount
        translation(lang: $language) {
          name
          description
        }
      }
      privatePrices(currency: $currency) {
        id
        price
        minGroupSize
      }
    }
  }
  ${PRODUCT_AVAILABILITY_FRAGMENT}
`;
